module.exports = __webpack_public_path__ + "static/media/photography-playful.a4a52dbf.svg";